import { postStat } from 'api/stats/stats.api'
import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import NewButton from 'ui/atoms/NewButton/NewButton'
import Datetime from 'utils/datetime/datetime'
import { pickerSelectionToDayRange, recentDayRange } from './SettlementExportButton.helper'
import { SettlementExportDialog } from './SettlementExportDialog'
import { useSettlementExportAccess } from './useSettlementExportAccess'

type SettlementExportButtonProps = {
  period: Period
}

export function SettlementExportButton({ period }: SettlementExportButtonProps): ReactNode {
  const { t } = useTranslation()
  const { canView, canRun } = useSettlementExportAccess()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  if (!canView) return null

  const headerPickerRange =
    pickerSelectionToDayRange(Datetime.toISOString(period.startTime), Datetime.toISOString(period.endTime)) ??
    recentDayRange(1)

  function handleOpen(): void {
    setIsDialogOpen(true)
    postStat(`settlement-export`, `open-settlement-export-dialog`)
  }

  return (
    <>
      <NewButton variant="outlined" label={t(`Settlement export`)} icon="fas fa-file-excel" onClick={handleOpen} />
      {isDialogOpen && (
        <SettlementExportDialog
          canRun={canRun}
          initialRunRange={headerPickerRange}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  )
}
